import { ContentfulSupportArticle } from '@jbhi-fi/apis/src/contentful/types';
import { SupportArticleProps } from './SupportArticle';

export class SupportArticleTransformer {
  static toSupportArticleProps = (entry: ContentfulSupportArticle): SupportArticleProps => {
    return {
      heading: entry.fields?.heading ?? '',
      content: entry.fields?.mainBody,
    };
  };
}
